(function () {
    'use strict';
    angular.module('app.core').config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('lead',
                {
                    url: '/:langcode/lead/:id',
                    templateUrl: 'app/history/lead.html',
                    controller: 'LeadController',

                    params: {
                        langcode: {
                            value: ['$translate', function ($translate) {
                                return $translate.use();
                            }]
                        },
                        finger: { type: 'any', raw: true },
                        path: ['$translate', function ($translate) {
                            return $translate.instant("agent-detail");
                        }],
                    },
                    resolve: {
                        lazyLoad: ['$transition$', 'lazyLoadSvc', function ($transition$, lazyLoadSvc) {
                            return lazyLoadSvc.load($transition$, 'leadHistory');
                        }],

                        lead: [
                            "$transition$",
                            "$q",
                            "consultancy_factory",
                            "historyService",
                            "notifierSvc",
                            "$translate",
                            "$rootScope",
                            "$window",
                            "userSvc",
                            "restoreUrlService",
                            function ($transition$, $q, consultancy_factory, historyService, notifierSvc, $translate, $rootScope, $window, userSvc, restoreUrlService) {
                                var defer = $q.defer();

                                userSvc.getUserInfo(null, true).then(function () {
                                    const id = $transition$.params().id;
                                    if (!id) defer.resolve({consultancy: null, detail: ''});
                                    consultancy_factory.detailForAgent({ consultancyId: id }).$promise.then(function (result) {
                                        if (result && result.consultancy) {
                                            historyService.get({ fingerPrint: result.consultancy.fingerPrint }).then(function (data) {
                                                const lead = Object.assign(result, {history: data});
                                                defer.resolve(lead);
                                            }).finally(() => defer.resolve(result));
                                        }
                                        else
                                            defer.resolve(result);
                                    }, function (err) {
                                        let msg;
                                        if (err.data.detail.indexOf('You have no permission') !== -1 ||
                                        err.data.detail.indexOf('request is unavailable') !== -1)
                                            msg = $translate.instant('no_lead_permission');
                                        else if (err.data.detail.indexOf('has been accepted by another user') !== -1)
                                            msg = $translate.instant('accept_another');
                                        else if (err.data.detail.indexOf('Consultancy not found') !== -1)
                                            msg = $translate.instant('lead_not_found');

                                        notifierSvc.show({message: msg, type: 'error'});
                                        $transition$.abort();
                                        restoreUrlService.returnTo();
                                        $('.before-load').addClass("ng-hide");
                                        $rootScope.hideBar = false;
                                        $window.barLoaded = true;
                                        defer.resolve();
                                    });
                                },
                                function () {
                                    $transition$.router.stateService.go('signin', { langcode: $window.lang });
                                });

                                return defer.promise;
                            }
                        ],
                        translations: ['$translatePartialLoader', '$translate', function ($translatePartialLoader, $translate) {
                            $translatePartialLoader.addPart("agents");
                            $translatePartialLoader.addPart('consult_expert');
                            return $translate.refresh();
                        }],
                        title: ['$translate', function ($translate) {
                             return $translate('lead_requests').then(function (res){
                                return  res
                            })
                        }]
                    },
                    metaTags: {
                        title: '{{title}}',
                        robots: 'noindex, nofollow',
                        properties: {
                            "og:image": "http://www.endeksa.com/og_image3.png", "og:image:secure_url": 'https://www.endeksa.com/og_image3.png',
                            "og:type": "website",
                        },
                    }
                })
    }]);

})();
